const __filename = "/app/views/blog/index.js", __dirname = "/app/views/blog";
import LazyLoad from 'vanilla-lazyload'

new LazyLoad({ elements_selector: '.lazy' })
